import './Status.scss';

import { Button, Col, Row, Tab } from 'react-bootstrap';
import {
  ENTER_KEY_CODE,
  PROFIL_TABS,
  ROUTE_PROFILE_NAME
} from '../../utils/constants';
import { Route, Routes, useBeforeUnload, useNavigate } from 'react-router-dom';
import {
  checkUserStatus,
  deleteCandidate,
  fetchEnums,
  selectIsDeletingCandidate,
  selectUserStatus
} from '../../ducks/entities';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ErrorCard from '../../components/ErrorCard/ErrorCard';
import GamesPlayed from './GamesPlayed';
import GamingHabits from './GamingHabits';
import LoaderComponent from '../../components/Loader/LoaderComponents';
import ModalTemplate from '../../components/ModalTemplate/ModalTemplate';
import PersonalInformation from './PersonalInformation';
import Playtests from './Playtests';
import UnsavedWarningModal from '../../components/UnsavedWarningModal/UnsavedWarningModal';
import checkImg from '../../assets/images/ubisoft-playtest-icon-dots-black.webp';
import cn from 'classnames';
import messages from './messages';
import { selectLocalSettings } from '../../ducks/settings';
import siteMessages from '../root/siteMessages';
import tabImg01 from '../../assets/images/ubisoft-playtest-profile-icon-user-black.webp';
import tabImg02 from '../../assets/images/ubisoft-playtest-profile-icon-dialogue-black.webp';
import tabImg03 from '../../assets/images/ubisoft-playtest-profile-icon-intelligence-black.webp';
import tabImg04 from '../../assets/images/ubisoft-playtest-profile-icon-smiley-black.webp';
import tabImgActive01 from '../../assets/images/ubisoft-playtest-profile-icon-user-white.webp';
import tabImgActive02 from '../../assets/images/ubisoft-playtest-profile-icon-dialogue-white.webp';
import tabImgActive03 from '../../assets/images/ubisoft-playtest-profile-icon-intelligence-white.webp';
import tabImgActive04 from '../../assets/images/ubisoft-playtest-profile-icon-smiley-white.webp';
import { toast } from 'react-toastify';
import { useIntl } from 'react-intl';
import { useToggle } from 'react-use';
import warningImg from '../../assets/images/ubisoft-playtest-icon-warning-black.webp';

interface OwnProps {
  isFormModified: boolean;
  setFormModified(value: boolean): void;
  setShowingWarning(value: boolean): void;
  setShowedWarning(value: boolean): void;
}

const Status = (props: OwnProps) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userStatus = useSelector(selectUserStatus);
  const [isFieldModified, setIsFieldModified] = useState(false);
  const [showDeleteModal, toggleDeleteModal] = useToggle(false);
  const [showModalWarning, toggleModalWarning] = useToggle(false);
  const [pathToNavigate, setPathToNavigate] = useState('');
  const isDeleting = useSelector(selectIsDeletingCandidate);
  const lang = useSelector(selectLocalSettings);
  const notCompleted: boolean = Object.values(userStatus).some((v) => !v);

  useBeforeUnload(
    useCallback(
      (event) => {
        if (!isFieldModified) return;
        event.preventDefault();
        event.returnValue = true;
      },
      [isFieldModified]
    )
  );

  useEffect(() => {
    setIsFieldModified(props.isFormModified);
  }, [props.isFormModified]);

  useEffect(() => {
    props.setFormModified(isFieldModified);
  }, [isFieldModified]);

  useEffect(() => {
    props.setShowedWarning(showModalWarning);
  }, [showModalWarning]);

  const TABS = [
    {
      pathname: PROFIL_TABS[0].pathname,
      sectionName: 'personalInfo',
      component: (
        <PersonalInformation setIsFieldModified={setIsFieldModified} />
      ),
      icon: tabImg01,
      iconActive: tabImgActive01
    },
    {
      pathname: PROFIL_TABS[1].pathname,
      sectionName: 'playtest',
      component: <Playtests setIsFieldModified={setIsFieldModified} />,
      icon: tabImg02,
      iconActive: tabImgActive02
    },
    {
      pathname: PROFIL_TABS[2].pathname,
      sectionName: 'gamingHabits',
      component: <GamingHabits setIsFieldModified={setIsFieldModified} />,
      icon: tabImg03,
      iconActive: tabImgActive03
    },
    {
      pathname: PROFIL_TABS[3].pathname,
      sectionName: 'gameExperiences',
      component: <GamesPlayed />,
      icon: tabImg04,
      iconActive: tabImgActive04
    }
  ];

  useEffect(() => {
    dispatch(checkUserStatus());
  }, []);

  useEffect(() => {
    if (location.pathname === `/${lang}/${ROUTE_PROFILE_NAME}`) {
      navigate(
        `${location.pathname.substring(0, 6)}/${ROUTE_PROFILE_NAME}/${
          PROFIL_TABS[0].pathname
        }`,
        { replace: true }
      );
    }
  }, [location.pathname]);

  const onClick = (event: any, path: string) => {
    if (isFieldModified) {
      toggleModalWarning(true);
      setPathToNavigate(path);
    } else {
      navigate(`${path}`, { state: { prevRoute: location.pathname } });
    }
    event.preventDefault();
  };

  const onClickDelete = async () => {
    await (dispatch(deleteCandidate()) as any).then(() => {
      toggleDeleteModal(false);
      dispatch(fetchEnums());
      toast.success(intl.formatMessage({ ...messages.redirectToHome }));
      navigate(`/${lang}/`);
    });
  };

  const onWarningConfirmation = () => {
    toggleModalWarning(false);
    setIsFieldModified(false);
    props.setShowedWarning(true);
    navigate(`${pathToNavigate}`);
  };

  return (
    <div className="all">
      {showModalWarning && (
        <UnsavedWarningModal
          onClose={() => toggleModalWarning(false)}
          onClick={onWarningConfirmation}
        />
      )}
      {showDeleteModal && (
        <ModalTemplate
          onClose={() => toggleDeleteModal(false)}
          isLoading={isDeleting}
          text={intl.formatMessage({ ...messages.deleteConfirmationText })}
          subtext={intl.formatMessage({
            ...messages.deleteConfirmationSubText
          })}
          confirmBtn={
            <Button
              className="btn-danger-plain"
              onClick={onClickDelete}
              disabled={isDeleting}
            >
              <LoaderComponent isLoading={isDeleting} className="lds-small">
                {intl.formatMessage({ ...siteMessages.delete })}
              </LoaderComponent>
            </Button>
          }
        />
      )}
      <Row>
        <Col className="menu">
          <div className="tabs">
            {TABS.map(({ pathname, sectionName, icon, iconActive }, index) => (
              <a
                href={`${pathname}`}
                key={index}
                className={cn(
                  location.pathname.includes(pathname) && 'tab--active'
                )}
                onClick={(event) => onClick(event, pathname)}
              >
                <div>
                  <img
                    src={
                      location.pathname.includes(pathname) ? iconActive : icon
                    }
                    alt=""
                    className="img-transform"
                  />
                  <span>
                    {intl.formatMessage({ ...(messages as any)[pathname] })}
                  </span>
                  <div className="ms-auto">
                    <img
                      src={
                        !(userStatus as any)[sectionName]
                          ? warningImg
                          : checkImg
                      }
                      alt={intl.formatMessage({ ...siteMessages.iconWarning })}
                      className="tab-status"
                    />
                  </div>
                </div>
              </a>
            ))}
          </div>
          {notCompleted && (
            <div className="mt-4 d-flex align-items-center">
              <img
                src={warningImg}
                alt={intl.formatMessage({ ...siteMessages.iconWarning })}
              />
              <span className="ms-n1">
                {intl.formatMessage({ ...messages.profileStatus })}
              </span>
            </div>
          )}
        </Col>
        <Col className="status-content">
          <Tab.Content>
            <Routes>
              {TABS.map(({ pathname, component }, index) => (
                <Route
                  path={pathname}
                  element={component}
                  key={index}
                  errorElement={
                    <ErrorCard
                      text={intl.formatMessage({
                        ...siteMessages.ERROR_MESSAGE
                      })}
                    />
                  }
                />
              ))}
            </Routes>
          </Tab.Content>
        </Col>
      </Row>
      <div className="suppression">
        <Button
          variant="link"
          onClick={toggleDeleteModal}
          tabIndex={0}
          onKeyDown={(e: any) => {
            if (e.keyCode == ENTER_KEY_CODE) e.target.click();
          }}
        >
          {intl.formatMessage({ ...messages.deleteButton })}
        </Button>
      </div>
    </div>
  );
};

export default Status;
